import { TZoneSetting, ZoneSettingEnum } from './ZoneSetting';

/**
 * Extract the AI extended prompt value from zone settings.
 * Returns the prompt string if the setting exists and is enabled, otherwise undefined.
 */
export function getExtendedPrompt(zoneSettings: TZoneSetting[]): string | undefined {
	const setting = zoneSettings.find(
		(s) => s.zone_setting_enum_id === ZoneSettingEnum.ai_extended_prompt
	);
	if (setting?.enabled && setting.value) {
		return setting.value;
	}
	return undefined;
}
